import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { indexOf } from 'lodash';
import { withRouter } from 'react-router-dom';

// Import Selectors
import { getUser } from '../../modules/Auth/AuthReducer';

export default function (ComposedComponent, ...validRoles) {
  class PIPermissions extends Component {
    componentWillReceiveProps(nextProps) {
      const { user } = nextProps;
      const isPI = this.isPI(user);
      if (!isPI) {
        this.context.router.history.push('/');
      }
    }

    isPI(user) {
      return user.role && indexOf(validRoles, user.role) >= 0;
    }

    render() {
      const { user } = this.props;
      const isPI = this.isPI(user);
      if (!isPI) {
        return (
          <div className="container text-center">
            <div className="alert alert-danger">
              <p>Permission Denied</p>
            </div>
          </div>
        );
      }
      return <ComposedComponent {... this.props} />;
    }
  }

  // Retrieve data from store as props
  function mapStateToProps(state) {
    return {
      user: getUser(state),
    };
  }

  PIPermissions.propTypes = {
    dispatch: PropTypes.func.isRequired,
    user: PropTypes.shape({
      user_id: PropTypes.string,
      role: PropTypes.string,
    }).isRequired,
    location: PropTypes.shape({}).isRequired,
  };


  PIPermissions.contextTypes = {
    router: PropTypes.object,
  };


  return withRouter(connect(mapStateToProps)(PIPermissions));
}
